import { useState } from 'react';

import {
  Checkbox,
  FormControl,
  FormLabel,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { ExamDiploma } from '../../../types';
import { formatTime } from '../../../utils/common';

interface ExamLineSelectorProps {
  examLines: ExamDiploma[];
  selectedExamLineIds?: string[];
  onChange: (examLineIds: string[]) => void;
}

const ExamLineSelector = (props: ExamLineSelectorProps) => {
  const { examLines, onChange } = props;

  const [selectedExamLineIds, setSelectedExamLineIds] = useState<string[]>(
    props.selectedExamLineIds ? [...props.selectedExamLineIds] : [],
  );

  const handleExamLineChange = (examLine: ExamDiploma, checked: boolean) => {
    const selectedIds = [...selectedExamLineIds];

    if (checked) {
      selectedIds.push(examLine.id);
    } else {
      const existingExamIndex = selectedIds.findIndex(
        (id) => id === examLine.id,
      );

      if (existingExamIndex !== -1) {
        selectedIds.splice(existingExamIndex, 1);
      }
    }

    setSelectedExamLineIds(selectedIds);
    onChange(selectedIds);
  };

  return (
    <FormControl>
      <FormLabel>Bij welke onderdelen wil je aanwezig zijn?</FormLabel>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell variant="head" />
            <TableCell variant="head">Diploma</TableCell>
            <TableCell variant="head">Aantal</TableCell>
            <TableCell variant="head">Starttijd</TableCell>
            <TableCell variant="head">Eindtijd</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {examLines.map((examLine) => (
            <TableRow>
              <TableCell>
                <Checkbox
                  checked={selectedExamLineIds.includes(examLine.id)}
                  onChange={(_event, checked) => {
                    handleExamLineChange(examLine, checked);
                  }}
                />
              </TableCell>
              <TableCell>{examLine.diplomaType.name}</TableCell>
              <TableCell>{examLine.numberParticipants}</TableCell>
              <TableCell>{formatTime(new Date(examLine.beginTime))}</TableCell>
              <TableCell>{formatTime(new Date(examLine.endTime))}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </FormControl>
  );
};

export default ExamLineSelector;
